export default __webpack_public_path__ + "assets/falling-stars.9c118fd2.svg";